var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"income-chart"},[_c('div',{ref:"incomeChart",attrs:{"id":"income-chart"}}),(!_vm.hasData)?_c('div',[_c('div',{staticStyle:{"font-size":"14px","color":"#dcdfe6"}},[_vm._v("暂无数据")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }